import { Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFiles } from "@tabler/icons-react";
import FilesModal from "src/components/shared/_Modals/FilesModal/FilesModal";

import { useVaccineAttachments } from "../MedicalPatientInformation/MedicalDocumentsModal.hooks";

interface Props {
  inputId: string;
  vaxid: string | null;
  initialAttachments?: any[];
  vaccineName?: string;
}

const VaccineAttachment = ({
  vaxid,
  initialAttachments,
  vaccineName,
}: Props) => {
  const [opened, { open, close }] = useDisclosure(false);

  const { attachments, isUploading, handleUpload, handleRemove } =
    useVaccineAttachments(vaxid, initialAttachments || []);

  const attachmentCount = attachments.length;

  return (
    <>
      <Button
        variant="outline"
        size="xs"
        style={{
          width: "100%",
          minWidth: 125,
          cursor: vaxid ? "pointer" : "default",
          ...(!vaxid && {
            color: "gray",
            borderColor: "transparent",
            backgroundColor: "#eee",
          }),
        }}
        leftSection={<IconFiles size={14} />}
        onClick={vaxid ? open : () => {}}
        title={
          vaxid
            ? "Manage vaccine attachments"
            : "You need to save the entry before adding attachments"
        }>
        {attachmentCount > 0
          ? `${attachmentCount} File${attachmentCount > 1 ? "s" : ""}`
          : "Attachments"}
      </Button>

      {opened && (
        <FilesModal
          opened={opened}
          close={close}
          _files={attachments}
          handleUpload={handleUpload}
          isUploading={isUploading}
          customHandleRemove={handleRemove}
          modalTitle={`${vaccineName || ""} Vaccine Attachments`}
          hideRemovedToggle={true}
          readonly={false}
          patientId={vaxid}
        />
      )}
    </>
  );
};

export default VaccineAttachment;
